export const SOURCE = { name: 'MeoHost', network: 'MeoHost Bursa', url: 'https://meohost.com/operasyon-merkezi' };
export const regionNames = new Intl.DisplayNames(['de-CH'], { type: 'region' });
export const countryName = code => { try { return regionNames.of(code) || code; } catch (_) { return code; } };
export const number = value => Number.isFinite(value) ? new Intl.NumberFormat('de-CH', { maximumFractionDigits: 1 }).format(value) : '—';
export const compact = value => Number.isFinite(value) ? new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(value) : '—';
export const clock = value => value ? new Date(value).toLocaleTimeString('de-CH', { timeZone: 'Europe/Zurich', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—';
export const category = code => ({ syn: 'SYN Flood', udp: 'UDP Flood', icmp: 'ICMP Flood', flood: 'DDoS-Angriff', port: 'Port-Ratenlimit', scan: 'Port-Scan', brute: 'Brute Force' }[code] || '—');

export function isFresh(data, available, now = Date.now()) {
  if (!available || !data?.fresh || !data.measurementAt) return false;
  const at = Date.parse(data.at), measured = Date.parse(data.measurementAt);
  return Number.isFinite(at) && Number.isFinite(measured) && at <= now + 5000 && measured <= now + 5000 && now - at < 65000 && now - measured < 60000;
}

export function activeCountries(data, fresh, now = Date.now()) {
  const activity = data?.mapActivity;
  const age = now - Date.parse(activity?.sampledAt);
  if (!fresh || !activity?.fresh || !Number.isFinite(age) || age < -5000 || age > 120000) return [];
  const codes = new Set(activity.codes);
  return (data.countries || []).filter(c => c.count > 0 && codes.has(c.code)).sort((a, b) => b.count - a.count || a.code.localeCompare(b.code));
}

export function curve(point, target) {
  const control = { x: (point.x + target.x) / 2, y: Math.max(8, Math.min(point.y, target.y) - 30 - .24 * Math.abs(point.x - target.x)) };
  return { control, d: `M ${point.x} ${point.y} Q ${control.x} ${control.y} ${target.x} ${target.y}` };
}

export function windowData(data, range) {
  if (!data || range !== '1h') return data;
  const end = Date.parse(data.window?.to), from = end - 3600000;
  return { ...data, blockedPackets: data.lastHour?.blockedPackets ?? null, attackCount: data.lastHour?.attackCount ?? null,
    window: { from: new Date(from).toISOString(), to: data.window?.to },
    series: (data.series || []).filter(p => p.t + 300000 > from && p.t <= end) };
}
